import React from "react";

import SiteRouting from "./routing/SiteRouting";
import FramedModules from "./routing/FramedModules";

function Application() {
  /**
   * Special handling when the web app is iframed on our marketing site
   * or a partner site (embedded menu) 
   */
  if (window.self !== window.top) {
    return <FramedModules />
  } else {
    return <SiteRouting />
  }
}

export default Application;
